import { render, staticRenderFns } from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=template&id=37d29f76&scoped=true&"
import script from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellMarketingItemEmailPack.vue?vue&type=style&index=0&id=37d29f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d29f76",
  null
  
)

export default component.exports